import { lazy } from 'react'

import { SimulacaoRapidaGuard } from '@/routes/guards'

const HistoricoPage = lazy(() =>
  import('../pages').then((module) => ({ default: module.HistoricoSimulacaoPropostaPage })),
)

export const chileHistoricoRoutes = [
  {
    path: 'es-CL/historico/simulacoes',
    element: <HistoricoPage />,
  },
  {
    path: 'es-CL/historico/propostas',
    element: <HistoricoPage />,
  },
  {
    path: 'es-CL/historico/simulacoes-rapidas',
    element: (
      <SimulacaoRapidaGuard>
        <HistoricoPage />
      </SimulacaoRapidaGuard>
    ),
  },
]
